<template>
  <section class="section container">
    <div class="container mt-0 mb-6">
      <h1 class="title is-4 mb-3 is-pulled-right">
        {{ $t("script module settings") }}
      </h1>
    </div>

    <h1 class="title is-5">{{ $t("compilers location") }}</h1>
    <div class="columns mt-5">
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("nodejs compiler path") }}</label>
          <div class="control has-icons-left has-icons-right">
            <input
              class="input"
              type="text"
              v-model="meta.nodejs_compiler_path"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-server"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("python compiler path") }}</label>
          <div class="control has-icons-left has-icons-right">
            <input
              class="input"
              type="text"
              v-model="meta.python_compiler_path"
            />
            <span class="icon is-small is-left">
              <i class="fa fa-database"></i>
            </span>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label">{{ $t("bash compiler path") }}</label>
          <div class="control has-icons-left has-icons-right">
            <input class="input" type="text" v-model="meta.sh_compiler_path" />
            <span class="icon is-small is-left">
              <i class="fa fa-database"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="container mt-6">
      <div class="field mt-5">
        <div class="control">
          <button class="button is-rounded is-primary" @click="save">
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  save_configuration,
  get_configuration,
  post,
  error_message,
  success_message,
} from "@/utils";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";

export default {
  name: "FactoringSettings",
  components: { GenericDropdown },
  data() {
    return {
      meta: {},
    };
  },
  methods: {
    save() {
      let v = this;
      let data = v.meta;
      v.$root.loader(true);
      save_configuration(this, data)
        .then((response) => {
          console.log("configuration saved", response);
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => v.$root.loader(false));
    },
    test_connection() {
      let v = this;
      let data = {
        server: v.meta.wealth_status_datasource_server,
        database: v.meta.wealth_status_datasource_database,
        username: v.meta.wealth_status_datasource_username,
        password: v.meta.wealth_status_datasource_password,
      };
      v.$root.loader(true);
      post("/factoring/test-wealth-status-datasource", data)
        .then(() => {
          success_message(v.$t("connection succedded"));
        })
        .catch((error) => {
          error_message(error);
        })
        .finally(() => v.$root.loader(false));
    },
    sirc_script_changed(value) {
      this.meta.sirc_script_directory = value.directory;
    },
    sat_script_changed(value) {
      this.meta.sat_script_directory = value.directory;
    },
    wealth_status_script_changed(value) {
      this.meta.wealth_status_script_directory = value.directory;
    },
    sat_search_script_changed(value) {
      this.meta.sat_search_script_directory = value.directory;
    },
  },
  created() {
    let v = this;
    v.$root.loader(true);
    get_configuration(this)
      .then((conf) => {
        if (conf) {
          v.meta = conf;
          if (conf.sirc_script_directory)
            v.$refs.sirc_script_dropdown.set_value(conf.sirc_script_directory);
          if (conf.sat_script_directory)
            v.$refs.sat_script_dropdown.set_value(conf.sat_script_directory);
          if (conf.wealth_status_script_directory)
            v.$refs.wealth_status_script_dropdown.set_value(
              conf.wealth_status_script_directory
            );
          if (conf.sat_search_script_directory)
            v.$refs.sat_search_script_dropdown.set_value(
              conf.sat_search_script_directory
            );
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => v.$root.loader(false));
  },
};
</script>

<style></style>
